import { CircleHelp } from "lucide-react";

import { IconButton } from "../components/ui";
import { t } from "../i18n/i18n";
import { useUi } from "../state/ui";
import { useHelp } from "./helpStore";
import { type HelpScreen, VIEW_SCREENS } from "./topics";

/** Bouton « ? » d'une vue (le `HelpButton` de l'iPad) : ouvre l'aide de cet écran, sur une fiche au besoin.
 *  Toujours le dernier bouton d'un en-tête, avant la croix (R7). `buttonSize` : `md` 32 px (en-tête de vue, défaut)
 *  ou `sm` 28 px (en-tête de panneau ou de fiche) ; `size` : taille de l'icône. */
export function HelpButton({
  screen,
  topic,
  className,
  size = 15,
  buttonSize = "md",
}: {
  screen: HelpScreen | null;
  topic?: string;
  className?: string;
  size?: number;
  buttonSize?: "sm" | "md";
}) {
  const openHelp = useHelp((s) => s.openHelp);
  return (
    <IconButton
      size={buttonSize}
      className={className}
      title={t("Aide de cet écran (touche ?)")}
      aria-label={t("Aide de cet écran")}
      onClick={() => openHelp({ screen, topic })}
    >
      <CircleHelp size={size} />
    </IconButton>
  );
}

/** Écran d'aide de ce qui est affiché : l'accueil, sinon la vue courante (null : vue à venir). */
export function currentHelpScreen(): HelpScreen | null {
  const { welcome, view } = useUi.getState();
  return welcome ? "accueil" : (VIEW_SCREENS[view] ?? null);
}
